// Sentry frontend instrumentation — initialized first in src/index.js so
// the SDK can wrap global error handlers and unhandled rejections before
// any app code runs.
//
// Gated on REACT_APP_SENTRY_DSN_FRONTEND being set at build time. If the
// env var is absent the SDK never initializes — zero runtime overhead.
//
// CRA requires the REACT_APP_ prefix for env vars to be inlined into the
// bundle (process.env.SENTRY_DSN won't work in the browser).
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN_FRONTEND;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    sendDefaultPii: false,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0") || 0,
    // Filter out noisy non-Error rejections (per Sentry's own recommendation)
    // and browser-injected errors we already suppress in index.js.
    ignoreErrors: [
      "Non-Error promise rejection captured",
      "Non-Error exception captured",
      /__firefox__/,
      /__crWeb/,
      /webkit\.messageHandlers/,
    ],
    integrations: [Sentry.browserTracingIntegration()],
  });
}

export { Sentry };
